import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { RelativeContainer } from "../../../../components/react/RelativeContainer";

export interface EastPaneLayoutProps {
	header?: React.ReactNode;
	topline?: React.ReactNode;
	children?: React.ReactNode;
	center?: boolean;
}

export const EastPaneLayout: React.FC<EastPaneLayoutProps> = ({ header, topline, children, center, ...props }) => (
	<div {...props} className="flex h-full flex-col">
		{header && (
			<div
				className={cx("flex shrink-0 grow-0 items-center p-4 font-medium text-base text-grey-900", topline && "pb-4")}
				data-testid="east-pane-layout-header"
			>
				{header}
			</div>
		)}
		{topline}
		{children && (
			<RelativeContainer
				className={cx(
					"flex-1 space-y-4 overflow-y-auto overflow-x-hidden px-4 pb-4",
					center && "flex items-center justify-center",
				)}
				data-testid="east-pane-layout-children"
			>
				{children}
			</RelativeContainer>
		)}
	</div>
);
